<mat-dialog-content class="adap-dialog-content">
  <app-dialog-header>
    <div class="adap-dialog-title">value recognition legend</div>
    <div class="header-actions">
      <button *ngIf="readonly" class="adap-btn-blank" (click)="edit()">
        edit <mat-icon svgIcon="cvx-pencil"></mat-icon>
      </button>
      <button *ngIf="!readonly" class="adap-btn-blank" (click)="cancel()">
        cancel <mat-icon svgIcon="cvx-close"></mat-icon>
      </button>
      <button
        *ngIf="!readonly"
        class="adap-btn-filled"
        (click)="save()"
        [disabled]="!valueRecognitionFormState?.isValid"
      >
        save <mat-icon>save</mat-icon>
      </button>
    </div>
  </app-dialog-header>

  <ng-container *ngIf="valueRecognitionFormState">
    <form
      [ngrxFormState]="valueRecognitionFormState"
      class="adap-form-container"
    >
      <div class="adap-dialog-content-scroll">
        <div>
          any changes made to the legend will only affect future projects.
          projects currently in flight will not be affected changes.
        </div>
        <app-value-recognition-tables
          [readonly]="readonly"
          [tablesInfo]="tablesInfo"
        ></app-value-recognition-tables>
      </div>
    </form>
  </ng-container>
</mat-dialog-content>
